import React, { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import NeedHelp from '../../components/need-help'

import { getSS, loadIndexPage } from '../../helpers'

const Failed: React.FC = (props: any) => {

  const navigate = useNavigate()
  const params = useParams()
  const membership_form = (window as any).KEW.collections.membership_form[0]
  const url = membership_form.private_form ? 'private/' + params.url : params.url
  const [ failureMsg, setFailureMsg ] = useState('')
  const membership = getSS('membership')
  const failure = getSS('api-error')

  useEffect(() => {
    document.title = 'Payment failed - ' + (window as any).KEW.collections.membership_form[0].meta_title
  })

  useEffect(() => {

    if (failure) {
      // console.log(failure);
      switch (failure) {
        case 'Braintree:processor_declined|2001|Insufficient Funds':
          setFailureMsg('It appears that you have insufficient funds in your account, so your payment was unsuccessful.')
          break;
        case 'Braintree:processor_declined|2004|Expired Card':
          setFailureMsg('It appears that your card has expired, so your payment was unsuccessful.')
          break;
        case 'Braintree:processor_declined|2010|Card Issuer Declined CVV':
          setFailureMsg('It appears that the CVV code you used is not valid, so your payment was unsuccessful.')
          break;
        case 'PCAPredict:InvalidAccountNumber':
            setFailureMsg('It appears that the bank account you used is not valid, so your regular gift could not be setup.')
            break;
        case 'PCAPredict:InvalidSortCode':
            setFailureMsg('It appears that the sort code you used is not valid, so your regular gift could not be setup.')
            break;
        case 'PCAPredict:NotDirectDebitCapable':
            setFailureMsg('It appears that the bank account you used is not direct debit capable, so your regular gift could not be setup.')
            break;
        default:
          if (membership.payment_type === "Regular") {
            setFailureMsg('It appears that the bank details you used are not valid, so your payment could not be set up.')
          } else {
            setFailureMsg('Something went wrong with your transaction and your payment was unsuccessful.')
          }
      }
    } else {
      if (membership.payment_type === "Regular") {
        setFailureMsg('It appears that the bank details you used are not valid, so your payment could not be set up.')
      } else {
        setFailureMsg('Something went wrong with your transaction and your payment was unsuccessful.')
      }
    }

  }, [failure, membership.payment_type])

  return (
    <>
      <div className="failed-page">
        <div className="row intro">
          <div className="large-12 columns box">
            <div className="intro-copy">
              <h1>We're sorry!</h1>
            </div>
          </div>
        </div>
        <div className="row intro-divider"></div>
        <div className="row box failed">
          <div className="row">
            <div className="large-8 columns">
              <p>{ failureMsg }</p>
              { membership.payment_type === 'Single' &&
                <p>
                  <button onClick={() => loadIndexPage(navigate, url)} className="link">Please click here to try again</button>, perhaps with a different card or by using PayPal instead. Or you can contact us at <a className="blue" href="mailto:membership@kew.org">membership@kew.org</a> or on <a href="tel:+44(0)208 332 3200">+44(0)208 332 3200</a> if you need further assistance.
                </p>
              }
              { membership.payment_type === 'Regular' &&
                <p>
                  <button onClick={() => loadIndexPage(navigate, url)} className="link">Please click here to try again</button>, perhaps with a different bank account instead. Or you can contact us at <a className="blue" href="mailto:membership@kew.org">membership@kew.org</a> or on <a href="tel:+44(0)208 332 3200">+44(0)208 332 3200</a> if you need further assistance.
                </p>
              }
            </div>
            <div className="large-4 columns">
              <div className="mobile-divider show-for-small-only"></div>
              <NeedHelp />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Failed